import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { ResponsiveRadialBar } from "@nivo/radial-bar";

import Typography from "../../../../components/Typography";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as ThumbDownIcon } from "../../../../build/images/nps-dashboard-icons/thumb_down.svg";
import { ReactComponent as ThumbUpIcon } from "../../../../build/images/nps-dashboard-icons/thumb_up.svg";
import Paperplane from "../../../Loading/Paperplane/Paperplane";

import "./classification-zone-profile-map.css";

export default function ClassificationZoneProfileMap({
  surveyInfosFromDateOne,
  isLoadingSurveyInfos,
}) {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [compilation, setCompilation] = useState({
    iniciadas: 0,
    completadas: 0,
  });
  const [answer, setAnswer] = useState({ enviadas: 0, respondidas: 0 });
  const [mood, setMood] = useState({ like: 0, deslike: 0 });
  const [percentage, setPercentage] = useState(0);
  const [graphComp, setGraphComp] = useState([]);
  const [graphAnswer, setGraphAnswer] = useState([]);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loadingMood, setLoadingMood] = useState(true);

  const progressBarStyle = {
    display: "flex",
    width: "100%",
    height: "16px",
    padding: "8px 10px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "32px",
    background:
      "linear-gradient(90deg, #C90000 0%, #FFB700 50.45%, #008908 100%)",
    position: "relative",
  };
  const ballStyle = {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "#008908",
    // transform: `translateX(${percentage - 50}%)`,
    border: "5px solid #fff",
    position: "relative",
    left: `${percentage - 50}%`,
  };

  async function getCompilationRate() {
    const response = await APIDashboard.getCompilationRate(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;

      const data2 = [
        {
          id: "Compilation",
          data: [
            {
              x: "Taxa de Compilação",
              // y: (95 * 100) / 100,
              y:
                Number(data[0].iniciadas) === 0
                  ? 0
                  : (
                      (Number(data[0].completadas) * 100) /
                      Number(data[0].iniciadas)
                    ).toFixed(),
              color: "#008908",
              colorTrack: "rgba(0, 137, 8, 0.20)",
            },
          ],
        },
      ];
      setGraphComp(data2);
      setCompilation(data[0]);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  async function getAnswerRate() {
    const response = await APIDashboard.getAnswerRate(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;
      const data2 = [
        {
          id: "Answer",
          data: [
            {
              x: "Taxa de resposta",
              // y: (19 * 100) / 20,
              y:
                Number(data[0].enviadas) === 0
                  ? 0
                  : (
                      (Number(data[0].respondidas) * 100) /
                      Number(data[0].enviadas)
                    ).toFixed(),
              color: "#C90000",
              colorTrack: "rgba(201, 0, 0, 0.20)",
            },
          ],
        },
      ];

      setGraphAnswer(data2);
      setAnswer(data[0]);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  async function getMoodMap() {
    const response = await APIDashboard.getMoodMap(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;
      let objMood = {
        like: 0,
        deslike: 0,
      };

      if (data.length) {
        const positiveMood = data.find((datum) => {
          return (
            datum.conceito === "Bom" ||
            datum.conceito === "bom" ||
            datum.conceito === "BOM"
          );
        });
        const negativeMood = data.find((datum) => {
          return (
            datum.conceito === "Ruim" ||
            datum.conceito === "ruim" ||
            datum.conceito === "RUIM"
          );
        });
        const greateMood = data.find((datum) => datum.conceito === "Ótimo");

        const totalPositiveMood =
          positiveMood && Number(positiveMood.count)
            ? Number(positiveMood.count)
            : 0;
        const totalNegativeMood =
          negativeMood && Number(negativeMood.count)
            ? Number(negativeMood.count)
            : 0;
        const totalGreateMood =
          greateMood && Number(greateMood.count) ? Number(greateMood.count) : 0;
        const total = totalPositiveMood + totalNegativeMood + totalGreateMood;
        // data
        //   .map((datum) => Number(datum.count))
        //   .reduce((a, b) => a + b);
        objMood.like = total
          ? (((totalPositiveMood + totalGreateMood) / total) * 100).toFixed(1)
          : "0";
        objMood.deslike = total
          ? ((totalNegativeMood / total) * 100).toFixed(1)
          : "0";
        setPercentage(objMood.like);
        setMood(objMood);
      } else {
        setPercentage(objMood.like);
        setMood(objMood);
      }
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  const CenteredMetric = ({ center, bars }) => {
    const ref = useRef(null);
    if (bars.length) {
      return (
        <text
          x={center[0]}
          y={center[1]}
          style={{
            fontSize: 32,
            fontFamily: "Inter",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "28px",
            fill: `${bars[0].color}`,
          }}
          textAnchor="middle"
          dominantBaseline="central"
          ref={ref}
        >
          {`${bars[0].value}%`}
        </text>
      );
    }

    return null;
  };

  const getAllData = async () => {
    setLoadingMood(true);

    await getCompilationRate();
    //await getAnswerRate();
    await getMoodMap();
    setDispareFilter(true);

    setLoadingMood(false);
  };

  useEffect(() => {
    getAllData();
    setDispareFilter(true);
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getAllData();
    }
  }, [filtersDashboard]);

  /*
  useEffect(() => {
    setLoadingMood(true);
  }, [filtersDashboard]);
*/
  return (
    <section className="classification-zone-profile-map">
      <div className="mood-map">
        <header className="mood-map__header">Mapa de humor</header>

        {loadingMood ? (
          <Paperplane />
        ) : (
          <div className="mood-map-classification">
            <div className="container-line">
              <ThumbDownIcon />

              <span className="container-line__line" />

              <ThumbUpIcon />
            </div>

            <div className="mood-map-percentage">
              <h6 className="mood-map-percentage__h6">{mood.deslike}%</h6>

              <h6 className="mood-map-percentage__h6">{mood.like}%</h6>
            </div>
          </div>
        )}

        {loadingMood ? null : (
          <div style={progressBarStyle}>
            <div style={ballStyle}></div>
          </div>
        )}
      </div>

      <div className="compilation-rate">
        <header className="compilation-rate__header">
          <h6 className="compilation-rate__header__h6">Taxa de compilação</h6>
        </header>

        {loadingMood ? (
          <div className="compilation-rate__loading">
            <Paperplane />
          </div>
        ) : (
          <div className="compilation-rate-graphic">
            {/* GRÁFICO */}
            <div className="compilation-rate-graphic__isGraphic">
              <ResponsiveRadialBar
                data={graphComp}
                maxValue={100}
                startAngle={0}
                endAngle={360}
                colors={{ datum: "data.color" }}
                tracksColor={"rgba(0, 137, 8, 0.20)"}
                borderWidth={0}
                borderColor={{
                  from: "color",
                  modifiers: [["darker", "0"]],
                }}
                innerRadius={0.8}
                cornerRadius={2}
                margin={{ top: 0, bottom: 0 }}
                enableRadialGrid={false}
                enableCircularGrid={false}
                radialAxisStart={null}
                circularAxisOuter={null}
                tooltip={({ bar }) => {
                  return (
                    <div className="tooltip-text-radial">
                      <Typography.H6 color={"white"}>
                        {`Completadas - ${bar.value}%`}
                      </Typography.H6>
                    </div>
                  );
                }}
                layers={["tracks", "bars", CenteredMetric]}
                legends={[]}
              />
            </div>

            <span className="compilation-rate-graphic__span">
              <p className="compilation-rate-graphic__span__p">
                <h1>{compilation.iniciadas}</h1>

                <h6>Iniciadas</h6>
              </p>

              <p className="compilation-rate-graphic__span__p">
                <h1>{compilation.completadas}</h1>

                <h6>Completadas</h6>
              </p>
            </span>
          </div>
        )}
      </div>

      <div className="answer-rate">
        <header className="answer-rate__header">
          <h6 className="answer-rate__header__h6">Taxa de resposta</h6>
        </header>

        {isLoadingSurveyInfos ? (
          <div className="compilation-rate__loading">
            <Paperplane />
          </div>
        ) : (
          <div className="answer-rate-graphic">
            {/* GRÁFICO */}
            <div className="answer-rate-graphic__isGraphic">
              <ResponsiveRadialBar
                data={[
                  {
                    id: "Answer",
                    data: [
                      {
                        x: "Taxa de resposta",
                        // y: (19 * 100) / 20,
                        y:
                          Number(surveyInfosFromDateOne.porcentagemClientes) ||
                          Number(surveyInfosFromDateOne.porcentagemClientes) ===
                            0
                            ? Number(
                                surveyInfosFromDateOne.porcentagemClientes
                              ).toFixed()
                            : "0",
                        color: "#C90000",
                        colorTrack: "rgba(201, 0, 0, 0.20)",
                      },
                    ],
                  },
                ]}
                maxValue={100}
                startAngle={0}
                endAngle={360}
                colors={{ datum: "data.color" }}
                tracksColor={"rgba(201, 0, 0, 0.20)"}
                borderWidth={0}
                borderColor={{
                  from: "color",
                  modifiers: [["darker", "0"]],
                }}
                innerRadius={0.8}
                cornerRadius={2}
                margin={{ top: 0, bottom: 0 }}
                enableRadialGrid={false}
                enableCircularGrid={false}
                radialAxisStart={null}
                circularAxisOuter={null}
                tooltip={({ bar }) => {
                  return (
                    <div className="tooltip-text-radial">
                      <Typography.H6 color={"white"}>
                        {`Respondidos - ${bar.value}%`}
                      </Typography.H6>
                    </div>
                  );
                }}
                layers={["tracks", "bars", CenteredMetric]}
                legends={[]}
              />
            </div>

            <span className="answer-rate-graphic__span">
              <p className="answer-rate-graphic__span__p">
                <h1>{surveyInfosFromDateOne.enviadas}</h1>

                <h6>Enviadas</h6>
              </p>

              <p className="answer-rate-graphic__span__p">
                <h1>{surveyInfosFromDateOne.clientes}</h1>

                <h6>Respondidos</h6>
              </p>
            </span>
          </div>
        )}
      </div>
    </section>
  );
}
